export const GIVEAWAYS = "giveaways";
export const SUBSCRIPTIONS = "subscriptions";
export const USER_SESSION = "userSessions";
export const PROMOS = "promos";

export const WINNER_TESTAMENT_AUDIT_LOGS = "winnerTestamentsAuditLogs";
